<template>
    <div class="filter-attribution"
         v-on-clickaway="closeTagList">
        <el-badge type="success"
                  class="filter-counter"
                  :value="tags.length"
                  :hidden="tags.length === 0">
            <el-button size="small"
                       round
                       plain
                       @click="toggleTagList">
                Tags
            </el-button>
        </el-badge>
        <div class="filter-attribution-data-list"
             v-if="show_tag_list">
            <div class="d-flex flex-row justify-content-end mb-2">
                <el-button size="small"
                           class="border-0" @click="closeTagList">
                    Close
                </el-button>
            </div>
            <tag-selector class="w-100 filter-select"
                           place-holder="Filter Tags"
                           :multiple="true"
                           :value="tags"
                           @change="setTempTags">
            </tag-selector>
            <div class="d-flex flex-row justify-content-between mt-4">
                <el-button type="default" size="small" round @click="clear">
                    Clear
                </el-button>
                <el-button type="success" size="small" round @click="apply">
                    Apply
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
import DashboardFilter from '../../../filters/dashboard-filter'
import {mixin as clickaway} from 'vue-clickaway'

export default {
    mixins: [clickaway],
    data() {
        return {
            show_tag_list: false,
            temp_tags: []
        }
    },

    computed: {
        tags() {
            return DashboardFilter.tags()
        }
    },

    methods: {
        toggleTagList() {
            this.show_tag_list = !this.show_tag_list
        },

        clear() {
            this.temp_tags = []
            this.apply()
        },

        apply() {
            DashboardFilter.setTags(this.temp_tags)
            this.show_tag_list = false
        },

        setTempTags(tags) {
            this.temp_tags = tags
        },

        closeTagList() {
            this.show_tag_list = false
        }
    }
}
</script>
<style lang="scss">
.filter-attribution {
    position: relative;
    z-index: 901;
}

.filter-counter sup.el-badge__content {
    top: 3px !important;
    right: 14px !important;
}

.filter-attribution-data-list {
    padding: 1rem;
    border: solid 1px #ddd;
    border-radius: 5px;
    position: absolute;
    top: 40px;
    left: 0;
    background-color: white;
    width: 20rem;
}
</style>
